export const ASSESSMENT_ROLES = [
  "Entrepreneur",
  "Founder",
  "Business Leader",
  "Manager",
  "Sales Professional",
  "HR / L&D Leader",
  "Young Professional",
  "Organisation (HR / Leadership)",
];

export const ROLE_TO_AUDIENCE = {
  Entrepreneur: "Entrepreneurs",
  Founder: "Founders",
  "Business Leader": "Business Leaders",
  Manager: "Managers",
  "Sales Professional": "Sales Professionals",
  "HR / L&D Leader": "HR / L&D Leaders",
  "Young Professional": "Young Professionals",
  "Organisation (HR / Leadership)": "Organisations",
};

export const DOMAIN_LABELS = {
  strategy: "Strategy",
  leadership: "Leadership",
  sales: "Sales & Commercial Excellence",
  business: "Business & Entrepreneurship",
  operations: "Operations & Execution",
  digital: "Digital & AI",
  customer: "Customer",
  people: "People & Organisation",
};

export const DOMAIN_GUIDANCE = {
  strategy: "Your next stage depends on clearer direction — seeing the whole board and making deliberate choices about where to play and how to win.",
  leadership: "Your growth now runs through other people — expanding your own leadership capacity is the highest-leverage investment available.",
  sales: "Commercial results are the constraint — sharper commercial thinking and disciplined execution would move your numbers fastest.",
  business: "You are building something of your own — the fundamentals of venture design and entrepreneurial discipline are your fastest path.",
  operations: "The gap between plans and delivery is your constraint — execution discipline and operational rhythm would release the most value.",
  digital: "Technology is reshaping your environment — executive fluency in digital and AI would let you lead that change instead of reacting to it.",
  customer: "Your next stage of growth lives with your customers — seeing the business from the outside in would unlock retention, pricing and referrals.",
  people: "Your results depend on how people work together — building manager effectiveness and organisational capability is the priority.",
};

export const ASSESSMENT_QUESTIONS = [
  {
    q: "Which challenge is most limiting progress right now?",
    options: [
      { label: "Our direction and priorities are not clear enough", scores: { strategy: 2 } },
      { label: "Too much depends on me personally", scores: { leadership: 2, business: 1 } },
      { label: "Revenue is inconsistent or below potential", scores: { sales: 2, customer: 1 } },
      { label: "Good plans keep failing in execution", scores: { operations: 2, people: 1 } },
    ],
  },
  {
    q: "When you look at your organisation's numbers, you…",
    options: [
      { label: "Read them fluently and decide from them", scores: { sales: 1, strategy: 1 } },
      { label: "Understand the basics but not the deeper economics", scores: { sales: 2 } },
      { label: "Rely on others to interpret them for you", scores: { sales: 1, leadership: 1 } },
      { label: "Find the people side harder than the numbers", scores: { people: 2 } },
    ],
  },
  {
    q: "A technology such as AI starts reshaping your industry. Your first move is to…",
    options: [
      { label: "Understand the strategic implications before acting", scores: { strategy: 2, digital: 1 } },
      { label: "Experiment hands-on to build fluency", scores: { digital: 2 } },
      { label: "Ask how it changes what customers expect", scores: { customer: 2, digital: 1 } },
      { label: "Work out how it changes operations and cost", scores: { operations: 2, digital: 1 } },
    ],
  },
  {
    q: "Your best customers stay with you mainly because…",
    options: [
      { label: "Deep relationships and real understanding of their goals", scores: { customer: 2 } },
      { label: "Price and convenience, honestly", scores: { customer: 1, strategy: 1 } },
      { label: "Our people — the relationships live with individuals", scores: { people: 2, customer: 1 } },
      { label: "We have not examined it rigorously", scores: { customer: 1, strategy: 1 } },
    ],
  },
  {
    q: "How would your team describe working with you?",
    options: [
      { label: "Clear expectations, coaching and real accountability", scores: { people: 1, leadership: 1 } },
      { label: "I am stretched too thin to lead them properly", scores: { leadership: 2 } },
      { label: "Capable individuals, but not one team", scores: { people: 2, leadership: 1 } },
      { label: "I am building my first real team now", scores: { business: 2, people: 1 } },
    ],
  },
  {
    q: "Where does growth mostly come from today?",
    options: [
      { label: "A deliberate strategy we have chosen and resourced", scores: { strategy: 1 } },
      { label: "My personal effort and network", scores: { business: 2, leadership: 1 } },
      { label: "A repeatable commercial engine", scores: { sales: 1, operations: 1 } },
      { label: "Opportunistically — we take what appears", scores: { strategy: 1, business: 1 } },
    ],
  },
  {
    q: "What does a typical week actually look like?",
    options: [
      { label: "Mostly firefighting and operational issues", scores: { operations: 2, leadership: 1 } },
      { label: "Split between today's work and building tomorrow's", scores: { strategy: 1, leadership: 1 } },
      { label: "Deep in selling and customer conversations", scores: { sales: 1, customer: 1 } },
      { label: "Managing people issues and coordination", scores: { people: 2 } },
    ],
  },
  {
    q: "Where do you most want to be stronger in 12 months?",
    options: [
      { label: "Strategic clarity and long-term direction", scores: { strategy: 2 } },
      { label: "Leading and multiplying through others", scores: { leadership: 2 } },
      { label: "Commercial and customer results", scores: { sales: 1, customer: 2 } },
      { label: "Building a business that runs without me", scores: { business: 2, operations: 1 } },
    ],
  },
];
